import { motion } from "framer-motion";
import { ChevronDown } from "lucide-react";

export const HeroSection = () => {
  const heroImage = "https://customer-assets.emergentagent.com/job_a514c27e-db5e-47bd-9e0a-eca1897bc21e/artifacts/2oxf3eos_Elise%20Redfiled%20.png";

  return (
    <section 
      className="relative h-screen w-full overflow-hidden bg-white"
      data-testid="hero-section"
    >
      {/* Background Image - centered, full height, natural width */}
      <div className="absolute inset-0 flex justify-center">
        <img
          src={heroImage}
          alt="Elise Redfield - Strength Coach"
          className="h-full w-auto max-w-none"
          style={{ objectFit: "cover", objectPosition: "center top" }}
        />
      </div>
      {/* Gradient overlays */}
      <div className="absolute inset-0 bg-gradient-to-r from-white/80 via-transparent to-white/80 pointer-events-none" />
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-white/90 pointer-events-none" />

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col justify-end pb-20 md:pb-32 px-6 md:px-12 max-w-screen-2xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.3 }}
          className="max-w-3xl"
        >
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.5 }}
            className="font-body text-xs md:text-sm tracking-[0.3em] uppercase text-graphite/60 mb-4"
          >
            Regenerative Strength & Longevity
          </motion.p>

          <h1 
            className="font-heading text-6xl sm:text-7xl md:text-8xl lg:text-9xl font-bold tracking-tighter uppercase leading-none text-graphite-dark mb-6"
            data-testid="hero-headline"
          >
            Age<br />
            Powerfully.
          </h1>

          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.7 }}
            className="font-body text-lg md:text-xl font-light tracking-[0.1em] text-graphite/70 mb-4"
          >
            Build Muscle. Sustainable Results. Lasting Vitality.
          </motion.p>

          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.8 }}
            className="font-body text-base md:text-lg font-light tracking-wide text-graphite/60 mb-10"
          >
            Take Back Your Power Through Movement
          </motion.p>

          <motion.a
            href="#apply"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.9 }}
            className="inline-block bg-graphite-dark text-bone font-heading tracking-widest uppercase px-8 py-4 hover:bg-black transition-colors"
            data-testid="hero-cta"
          >
            Book a Consultation
          </motion.a>
        </motion.div>

        {/* Scroll Indicator */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 1.2 }}
          className="absolute bottom-8 left-1/2 -translate-x-1/2"
        >
          <motion.div
            animate={{ y: [0, 8, 0] }}
            transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
          >
            <ChevronDown className="text-graphite/40" size={28} strokeWidth={1} />
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default HeroSection;
